export const getEngagementDesignState = () => ({
  editor: null,
  locale: "en-US",
  isEmptyCampaign: false,
  isEditorReady: false,
  isMultiLanguage: false,
  isMessageModified: false,
  isLoading: false,
  isNewMessageLoading: false,
  currency: "PLN",
  dynamicElementPriceFormatTypeId: 1,
  isFeedActiveOrTrackerIsOnOneClickIntegration: false,
  // All channels for the message
  availableChannelTypes: [],
  newsletterSubscriptionChannelType: null,
  // Selected channel
  messageChannelType: null,
  editorType: null,
  orderIndexes: [],
  orderIndex: null,
  groupId: null,
  engagement: null,
  engagementTypeId: 0,
  engagementMessageId: 0,
  couponPoolId: null,
  engagementLanguages: [],
  engagementMessageCount: 0,
  additionalMessageCount: 0,
  messageLanguage: null,
  optInTypeId: null,
  recommendationEventTypeId: null,
  groups: null,
  // Actual message that unlayer uses during design phase
  message: {
    subject: "",
    preheader: "",
    html: "",
    design: {},
  },
  isDev: false,
  isDemo: false,
  // For undo
  messageHistory: [],
  // Persist message during copy/paste operation
  messageClipboard: {
    hasData: false,
    subject: "",
    html: "",
    design: {},
  },
  utm: {
    isUTMModificationAllowed: false,
    campaign: "",
    source: "",
    medium: "",
    term: "",
    areOverwritten: false,
    urlToUpdate: "",
  },
  sender: {
    avatarUrl: "https://d3vhsxl1pwzf0p.cloudfront.net/images/static/no_fb.jpg",
    name: "",
  },
  categories: [],
  trackerProducts: [],
  templates: [],
  isTemplatesSectionVisible: false,
  templatesLoading: false,
});
